import RouteModule from 'containers/purchase/modules/route_module/route_module'
import routeState from 'containers/purchase/modules/route_module/route_state'
import TicketTypesModule from 'containers/purchase/modules/ticket_types_module/ticket_types_module'
import ticketTypesState from 'containers/purchase/modules/ticket_types_module/ticket_types_state'
// import TransferVehicleModule from 'containers/purchase/modules/transfer_vehicle_module/transfer_vehicle_module'
// import transferVehicleState from 'containers/purchase/modules/transfer_vehicle_module/transfer_vehicle_state'
// import TransferServiceModule from 'containers/purchase/modules/transfer_service_module/transfer_service_module'
// import transferServiceState from 'containers/purchase/modules/transfer_service_module/transfer_service_state'
// import QuotationsModule from 'containers/purchase/modules/quotations_module/quotations_module'
// import quotationsState from 'containers/purchase/modules/quotations_module/quotations_state'
import ContactModule from 'containers/purchase/modules/contact_module/contact_module'
import contactState from 'containers/purchase/modules/contact_module/contact_state'
import i18n from 'i18n/config'

const reservationMapper = (ctx) => {
  console.log(ctx)

  return {
    event_id: 'QT',
    ticket_types: ctx.ticket_types,
    params: {
      route_form: ctx.route_form
    }
  }
}

const config = (params) => {
  const {external_api_config} = params

  let steps = {}

  steps.routeStep = {
    component: RouteModule,
    componentProps: {
      title: i18n.t('servantrip_machine_config.pickup_step_module_title'),
      formName: 'route_form',
    },
    currentStep: 'route',
    target: '#purchase.ticketsStep',
    autoNext: false,
    states: routeState,
    context: {
      tickets: []
    }
  }

  // steps.transferServiceStep = {
  //   component: TransferServiceModule,
  //   componentProps: {
  //     title: i18n.t('servantrip_machine_config.transfer_service_step_module_title'),
  //   },
  //   currentStep: 'transferService',
  //   target: '#purchase.contactRequired',
  //   autoNext: false,
  //   states: transferServiceState,
  //   context: {
  //     tickets: []
  //   }
  // }

  steps.ticketsStep = {
    component: TicketTypesModule,
    autoNext: false,
    states: ticketTypesState,
    context: {
      event: {
        id: 'prueba'
      },
      tickets: []
    }
  }

  steps.contactRequired = {
    component: ContactModule,
    autoNext: false,
    states: contactState,
    context: {
      contactValues: []
    }
  }

  return {
    reservationMapper: reservationMapper,
    steps: steps,
    params: params,
  }
}

export default config
